/**
 * One quiet caption line that appears only once the companion budget is
 * mostly used (≥80%). The always-visible meter moved into the ⋯ overflow
 * menu — this is the ambient signal that surfaces exactly when it matters.
 * The exhausted state (budget fully spent) stays a separate, richer notice
 * (AssistantExhaustedNotice).
 */

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAssistantUsage } from './useAssistantUsage';

const USAGE_HINT_THRESHOLD = 80;

interface AssistantUsageHintProps {
  eventId: string;
  /** Bumped by the parent as turns complete, to keep the number fresh. */
  refreshKey?: number;
}

const AssistantUsageHint = ({ eventId, refreshKey }: AssistantUsageHintProps) => {
  const { t } = useTranslation();
  const used = useAssistantUsage(eventId, refreshKey);

  if (used == null || used < USAGE_HINT_THRESHOLD) return null;

  return (
    <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'center' }}>
      {t('assistant.usage.hint', { percent: used })}
    </Typography>
  );
};

export default AssistantUsageHint;
